'use client';

import { useEffect, useState } from 'react';

/**
 * Official-channel player for the Homepage broadcast slot (Figma 2165:29546).
 *
 * `src` already lists the hosts we know at build time. If this page is opened
 * on some other host, append that hostname after mount so the player is
 * allowed to frame there without reading request headers on the server.
 */
export function TwitchBroadcastPlayer({ title, src }: { title: string; src: string }) {
  const [url, setUrl] = useState(src);

  useEffect(() => {
    const host = window.location.hostname;
    if (!host || url.includes(`parent=${encodeURIComponent(host)}`)) return;
    const next = new URL(url);
    next.searchParams.append('parent', host);
    setUrl(next.toString());
  }, [url]);

  return (
    <div className="lh-broadcast-video">
      {/* `allow` already grants fullscreen; `allowFullScreen` is the legacy
          duplicate and wins a precedence warning in the console for no gain. */}
      <iframe
        src={url}
        title={title}
        allow="autoplay; fullscreen; picture-in-picture"
      />
    </div>
  );
}
